var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.collection)?_c('div',{staticClass:"nftdetailcollection"},[_c('a-placeholder',{attrs:{"content-loaded":!!_vm.collection.contract,"replacement-num-chars":15}},[_c('router-link',{attrs:{"to":{ name: 'explore', query: { collections: _vm.collection.contract } }}},[_vm._v(" "+_vm._s(_vm.collection.name)+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }